import React, { useEffect, useReducer, useState } from "react";
import Loader from "../../components/shared/Loader";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { updateMeta } from "../../store/actions/metaAction";
import userPlaceholder from "../../assets/images/placeholder.jpg";
import cookie from "js-cookie";
import server from "../../api/server";
import axios from "axios";
import { toast } from "react-toastify";

const FeatureCreate = () => {
	const auth = useSelector(state => state.auth.user);
	const history = useHistory();
	const dispatch = useDispatch();

	const [loading, setLoading] = useState(false);
	const [, forceUpdate] = useReducer(x => x + 1, 0);

	const {
		register,
		handleSubmit,
		formState: { errors },
		setValue,
		getValues,
		reset,
	} = useForm();

	const onStart = async () => {
		setLoading(true);
		dispatch(
			updateMeta({
				title: "اضافة ميزة جديدة",
				breadcrumb: "المميزات",
				button: {
					show: false,
					text: null,
					link: null,
				},
			})
		);
		setLoading(false);
	};

	const mainHandleImageUpload = async event => {
		setLoading(true);
		const file = event.target.files[0];
		if (!file) return;

		const formData = new FormData();
		formData.append("file", file);

		try {
			const response = await axios.post(
				`${process.env.REACT_APP_API_URL}/upload`,
				formData,
				{
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
						"Content-Type": "multipart/form-data",
					},
				}
			);

			const uploadedPath = response.data.data.file.path;

			// ✅ Set uploaded image path to icon field
			setValue("icon", uploadedPath);
			toast.success("تم رفع الصورة بنجاح!");
		} catch (error) {
			toast.error("خطأ، برجاء المحاولة مره اخرى!");
		} finally {
			setLoading(false);
		}
	};

	const submitHandler = async data => {
		setLoading(true);
		try {
			const finalData = {
				title: "features", // ✅ Fixed title
				name: data.name,
				icon: data.icon,
			};

			await server(cookie).post("/pages/features/sections", {
				section: finalData,
			});

			reset();
			forceUpdate();
			onStart();
			toast.success("تم حفظ الميزة بنجاح!");
		} catch (error) {
			console.error("Error submitting feature:", error);
			toast.error("حدث خطأ أثناء الحفظ");
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		onStart();
		register("icon", { required: true });
	}, []);

	return (
		<section>
			{loading && <Loader />}
			<form onSubmit={handleSubmit(submitHandler)}>
				<div className="row">
					<div className="col-md-12" style={{ height: 50 }} />

					<div className="col-md-4">
						<div className="card-body">
							<div className="form-item">
								<label htmlFor="picture">البانر</label>
								<input
									type="file"
									id="picture"
									onChange={mainHandleImageUpload}
								/>
								<input
									type="hidden"
									{...register("icon", { required: true })}
								/>
								<img
									src={
										getValues("icon")
											? `${process.env.REACT_APP_MAIN_URL}/${getValues("icon")}`
											: userPlaceholder
									}
									alt="preview"
									className="imagePreview"
								/>
							</div>
						</div>
					</div>

					<div className="col-md-8">
						<div className="card-body">
							<div className="form-item">
								<label htmlFor="featureAr">ميزة بالغة العربية</label>
								<input
									type="text"
									name="ar"
									id="featureAr"
									{...register("name.ar", { required: true })}
								/>
							</div>
							<div className="form-item">
								<label htmlFor="featureEn">ميزة بالغة الانجليزية</label>
								<input
									type="text"
									name="en"
									id="featureEn"
									{...register("name.en", { required: true })}
								/>
							</div>
						</div>
					</div>

					<div className="col-md-12" style={{ height: 50 }} />

					<div className="col-md-12">
						<div className="form-item mt-3">
							<button type="submit" className="bt bt-success btn-block">
								ارسال
							</button>
						</div>
					</div>
				</div>
			</form>
		</section>
	);
};

export default FeatureCreate;
